import React from "react";
import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";

const HANDSHAKE_IMG =
  "https://images.unsplash.com/photo-1518315064-bec5daa6062b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwyfHxidXNpbmVzcyUyMG1lZXRpbmclMjBoYW5kc2hha2V8ZW58MHx8fGJsYWNrX2FuZF93aGl0ZXwxNzgwODA0NTEzfDA&ixlib=rb-4.1.0&q=85";

const promises = [
  "Boardroom-grade discretion across every brief.",
  "One senior partner attached to every account, day one to launch.",
  "Daily dashboards · weekly reviews · zero invoicing surprises.",
  "Crisis response within 30 minutes — guaranteed.",
];

const Corporate = () => {
  return (
    <section
      id="corporate"
      data-testid="corporate-section"
      className="bg-[#0a0a0a] text-white border-t border-black"
    >
      <div className="section-gutter py-20 md:py-32 grid grid-cols-12 gap-6 md:gap-10">
        <div className="col-span-12 md:col-span-5">
          <div className="overline text-white/60">Chapter 03 — Corporate</div>
          <h2 className="font-serif-display text-5xl md:text-6xl lg:text-7xl mt-6 leading-[0.92]">
            For India&apos;s
            <br />
            <em>biggest names.</em>
          </h2>
          <p className="mt-8 text-base md:text-lg text-white/75 leading-relaxed max-w-md">
            We sit inside the war rooms of listed corporations, family conglomerates and
            institutional bodies — translating ambition into the language the country reads
            tomorrow morning.
          </p>

          <ul className="mt-10 space-y-4">
            {promises.map((p, i) => (
              <motion.li
                key={i}
                initial={{ opacity: 0, x: -16 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.08 * i }}
                className="flex items-start gap-3 text-sm md:text-base text-white/85"
                data-testid={`corp-promise-${i}`}
              >
                <CheckCircle2 size={18} className="mt-0.5 shrink-0 text-white" />
                <span>{p}</span>
              </motion.li>
            ))}
          </ul>
        </div>

        <div className="col-span-12 md:col-span-6 md:col-start-7">
          <div className="relative aspect-[4/5] w-full border border-white/20 overflow-hidden">
            <img
              src={HANDSHAKE_IMG}
              alt="Corporate handshake"
              className="w-full h-full object-cover"
              loading="lazy"
            />
            <div className="absolute top-4 left-4 text-[0.7rem] uppercase tracking-[0.22em] text-white/80 bg-black/60 backdrop-blur-sm px-3 py-1.5 border border-white/30">
              Plate 03 — Negotiation
            </div>
            <div className="absolute bottom-0 left-0 right-0 p-5 md:p-7 bg-black/80 backdrop-blur-sm border-t border-white/20">
              <div className="font-serif-display text-4xl md:text-5xl">100<span className="text-2xl align-top">%</span></div>
              <div className="mt-1 text-[0.7rem] uppercase tracking-[0.2em] text-white/70">
                Mandate success rate · 2021 – 2025
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Corporate;
